export function Meetings({ adminLink, sellerLink, getLinkAfterCreateRoom }) {
  return (
    <div>
      <h2 style={{ marginBottom: "20px", fontSize: "24px", fontWeight: "600" }}>Meetings</h2>
      <div style={{ background: "white", padding: "24px", borderRadius: "8px", border: "1px solid #e5e7eb" }}>
        <p>This is the meetings page content. Manage all your meetings here.</p>
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ marginBottom: "10px" }}>Meeting Management</h3>
          <ul>
            <li>Schedule new meetings</li>
            <li>View upcoming meetings</li>
            <li>Join ongoing meetings</li>
            <li>Review past meetings</li>
          </ul>
        </div>
      </div>
    </div>
  )
}
